export const isChromeHeadless = () => /HeadlessChrome/i.test(navigator.userAgent);

export function isCrawler() {
	// For now, only test for Googlebot
	// return /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);
	return /Googlebot/i.test(navigator.userAgent) || isChromeHeadless();
}
